var _rect, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMonetize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 15.2207,
    width: 44,
    height: 44,
    rx: 8,
    fill: "#1E2A10"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1881_1861)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.1172,
    cy: 37.2207,
    r: 13.1094,
    fill: "#AAEF77"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1881_1861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1397 46.4406C51.6393 43.7101 53.0256 40.1425 53.0256 36.4406C53.0256 32.7388 51.6393 29.1712 49.1397 26.4406C46.7061 23.6809 43.3042 21.963 39.6387 21.6428C35.9732 21.3226 32.325 22.4247 29.4497 24.7207C27.9445 26.0112 26.7168 27.5937 25.8407 29.3724C24.9646 31.151 24.4585 33.089 24.3529 35.0689C24.2472 37.0488 24.5443 39.0295 25.2261 40.8913C25.908 42.7531 26.9604 44.4573 28.3197 45.9006C29.6114 47.3685 31.1922 48.5538 32.9633 49.3822C34.7343 50.2107 36.6573 50.6645 38.6119 50.7152C40.5664 50.7659 42.5104 50.4123 44.322 49.6768C46.1336 48.9413 47.7737 47.8395 49.1397 46.4406Z",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1302 45.8506C49.634 43.1222 51.0232 39.5537 51.0232 35.8506C51.0232 32.1474 49.634 28.579 47.1302 25.8506C44.6983 23.0915 41.2982 21.3739 37.6343 21.0537C33.9704 20.7335 30.3238 21.8352 27.4502 24.1306C25.9397 25.4186 24.7064 26.9998 23.8248 28.7784C22.9432 30.557 22.4318 32.496 22.3215 34.478C22.2112 36.46 22.5043 38.4438 23.183 40.3092C23.8617 42.1746 24.912 43.8829 26.2702 45.3306C27.5636 46.8034 29.1478 47.9926 30.9233 48.8232C32.6987 49.6537 34.6269 50.1077 36.5864 50.1566C38.5459 50.2054 40.4943 49.848 42.3089 49.107C44.1235 48.3659 45.7651 47.2572 47.1302 45.8506Z",
    fill: "#161716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6499 31.4407C44.594 27.8821 42.2404 24.8497 39.055 22.9441C35.8696 21.0384 32.0848 20.3983 28.4499 21.1507C24.8148 21.8233 21.5807 23.8757 19.4242 26.8783C17.2678 29.8809 16.3561 33.6012 16.8799 37.2607C17.2171 39.2154 17.9475 41.0814 19.0269 42.7456C20.1063 44.4098 21.5122 45.8377 23.1595 46.9427C24.8068 48.0478 26.6612 48.807 28.6105 49.1745C30.5597 49.542 32.5633 49.5101 34.4999 49.0807C36.428 48.7264 38.2618 47.9767 39.8859 46.8788C41.51 45.7809 42.8891 44.3587 43.9366 42.7016C44.984 41.0445 45.6769 39.1885 45.9718 37.2505C46.2667 35.3124 46.1571 33.3343 45.6499 31.4407Z",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1201 32.8606C43.0643 29.3041 40.7122 26.2734 37.529 24.3679C34.3459 22.4624 30.5635 21.821 26.9301 22.5706C23.2962 23.2456 20.0636 25.2985 17.9076 28.3005C15.7515 31.3026 14.8388 35.0215 15.3601 38.6806C15.6973 40.6354 16.4277 42.5013 17.5071 44.1655C18.5865 45.8297 19.9924 47.2576 21.6397 48.3626C23.287 49.4677 25.1414 50.2269 27.0907 50.5944C29.0399 50.9619 31.0435 50.93 32.9801 50.5006C34.9072 50.1451 36.74 49.3946 38.3629 48.2962C39.9859 47.1978 41.3639 45.7754 42.4103 44.1184C43.4567 42.4615 44.1488 40.6059 44.443 38.6684C44.7373 36.731 44.6273 34.7535 44.1201 32.8606Z",
    fill: "#161716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7901 39.1507C40.0101 47.7707 32.9901 55.4107 24.1201 56.2207C19.5601 56.6407 14.0001 53.7307 11.0001 51.0407C8.17007 48.4907 7.77007 46.2907 7.67007 42.1007C7.45007 33.4907 14.4701 25.8507 23.3401 25.0307C26.2501 24.7607 27.7201 23.6607 30.1101 24.7607C32.3455 25.9887 34.3709 27.5651 36.1101 29.4307C38.4145 32.1532 39.7137 35.5847 39.7901 39.1507Z",
    fill: "#212E12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7901 39.1507C40.0101 47.7707 32.9901 55.4107 24.1201 56.2207C19.5601 56.6407 14.0001 53.7307 11.0001 51.0407C8.17007 48.4907 7.77007 46.2907 7.67007 42.1007C7.45007 33.4907 14.4701 25.8507 23.3401 25.0307C26.2501 24.7607 27.7201 23.6607 30.1101 24.7607C32.3455 25.9887 34.3709 27.5651 36.1101 29.4307C38.4145 32.1532 39.7137 35.5847 39.7901 39.1507Z",
    fill: "url(#paint0_linear_1881_1861)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7901 39.1507C40.0101 47.7707 32.9901 55.4107 24.1201 56.2207C19.5601 56.6407 14.0001 53.7307 11.0001 51.0407C8.17007 48.4907 7.77007 46.2907 7.67007 42.1007C7.45007 33.4907 14.4701 25.8507 23.3401 25.0307C26.2501 24.7607 27.7201 23.6607 30.1101 24.7607C32.3455 25.9887 34.3709 27.5651 36.1101 29.4307C38.4145 32.1532 39.7137 35.5847 39.7901 39.1507Z",
    fill: "url(#paint1_linear_1881_1861)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8452 51.3361C38.2854 46.1226 40.3937 36.2973 35.5541 29.3907C30.7145 22.4842 20.7597 21.1118 13.3194 26.3253C5.87916 31.5389 3.77094 41.3643 8.61054 48.2708C13.4501 55.1773 23.4049 56.5497 30.8452 51.3361Z",
    fill: "url(#paint2_linear_1881_1861)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8452 51.3361C38.2854 46.1226 40.3937 36.2973 35.5541 29.3907C30.7145 22.4842 20.7597 21.1118 13.3194 26.3253C5.87916 31.5389 3.77094 41.3643 8.61054 48.2708C13.4501 55.1773 23.4049 56.5497 30.8452 51.3361Z",
    fill: "url(#paint3_linear_1881_1861)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.893 49.9767C36.5236 45.3304 38.402 36.5737 34.0885 30.418C29.7751 24.2622 20.9031 23.0386 14.2724 27.6848C7.6418 32.3311 5.76339 41.0879 10.0769 47.2436C14.3904 53.3993 23.2623 54.623 29.893 49.9767Z",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0797 36.5807C20.7097 35.8507 20.3097 35.3807 20.2897 34.5807C20.2697 33.7807 20.7897 33.0107 22.2897 32.8707C23.2766 32.7637 24.2738 32.9333 25.1697 33.3607L25.7497 33.6207L26.7497 30.8907L26.3297 30.6907C25.3885 30.2628 24.3635 30.051 23.3297 30.0707V27.6907L20.6397 27.9407L20.7097 30.4807C19.6655 30.7485 18.7397 31.3553 18.0773 32.2058C17.415 33.0564 17.0536 34.1027 17.0497 35.1807C17.1197 37.8107 19.2997 38.7907 21.6397 39.4607C23.3997 39.9907 24.1297 40.6107 24.1597 41.6007C24.1897 42.5907 23.2397 43.5107 21.8097 43.6007C20.6698 43.7117 19.5224 43.4857 18.5097 42.9507L17.8997 42.6207L16.9697 45.3907L17.3297 45.6007C18.4421 46.1703 19.6806 46.449 20.9297 46.4107L20.9897 48.8807L23.6997 48.6307L23.6397 46.0107C24.7172 45.7188 25.671 45.0854 26.3579 44.2056C27.0449 43.3257 27.428 42.2468 27.4497 41.1307C27.3597 38.8407 26.0597 37.4807 23.0797 36.5807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3103 50.9906C9.31031 52.4606 8.82031 53.8806 9.95031 54.4406C13.0403 55.9706 26.2403 49.9406 37.0703 41.5906C47.2603 33.7406 55.2203 23.6506 55.0703 22.0306C54.9503 20.1606 52.2903 20.9806 49.9803 22.0306",
    stroke: "url(#paint4_linear_1881_1861)",
    strokeWidth: 0.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1881_1861",
    x: 0.0078125,
    y: 0.111328,
    width: 74.2188,
    height: 74.2188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_1881_1861"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1881_1861",
    x1: 20.1082,
    y1: 19.6932,
    x2: 17.1439,
    y2: 44.1868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAEF77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FCF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1881_1861",
    x1: 42.6505,
    y1: 46.2485,
    x2: 32.2338,
    y2: 56.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.557695,
    stopColor: "#84D349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D349",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1881_1861",
    x1: 18.4825,
    y1: 22.5031,
    x2: 32.1714,
    y2: 60.8758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAEF77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FCF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1881_1861",
    x1: 36.2489,
    y1: 13.8366,
    x2: 29.6003,
    y2: 39.6593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84D349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D349",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1881_1861",
    x1: 27.3831,
    y1: 57.2383,
    x2: 33.3595,
    y2: 16.8262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEFFFF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FBFFFF",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F8FFFF",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F7FFFF",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#F5FFFF",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5FFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1881_1861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.52,
    height: 43.78,
    fill: "white",
    transform: "translate(6 14.2207)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMonetize);
export default __webpack_public_path__ + "static/media/icon-monetize.6f249dc7b2ecda28f007b7c612bdb0a2.svg";
export { ForwardRef as ReactComponent };